import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { LienItemModel } from 'src/app/models/menu/lien-item.model';
import { ConfigService } from 'src/app/services/config/config.service';
import { CookiesService } from 'src/app/services/cookies.service';
import { IndividuSimpleModel } from '../../../models/individus/individu-simple.model';
import { MenuItemModel } from '../../../models/menu/menu-item.model';
import { MenuStateModel } from '../../../models/menu/menu-state.model';
import { UtilisateurCourantModel } from '../../../models/utilisateurs/utilisateur-courant.model';
import { NavigationService } from '../../../navigation/services/navigation.service';
import { TachesPopupControlService } from '../../../pages/gestion-taches/taches-popup-control.service';
import { IndividusService } from '../../../services/individus/individus.service';
import { MenuService } from '../../../services/menu/menu.service';
import { UtilisateurCourantService } from '../../../services/utilisateurs/utilisateur-courant.service';

const menusStatiques = {
  MonCompte: 'Profil',
  Taches: 'Tâches',
  PlanningTaches: 'Mon planning',
};

@Component({
  selector: 'app-menu-top',
  templateUrl: './menu-top.component.html',
  styleUrls: ['./menu-top.component.scss'],
})
export class MenuTopComponent implements OnInit, OnDestroy {
  user: UtilisateurCourantModel;
  individu: IndividuSimpleModel = null;

  menu: Array<MenuItemModel>;
  @Input() menuState: MenuStateModel;
  @Output() readonly menuStateChange: EventEmitter<MenuStateModel> = new EventEmitter<MenuStateModel>();
  private subs: Subscription[] = [];
  constructor(
    private utilisateurCourantService: UtilisateurCourantService,
    private menuService: MenuService,
    private individusService: IndividusService,
    private navigationService: NavigationService,
    private tachesControlService: TachesPopupControlService,
    private configService: ConfigService,
    private cookieService: CookiesService,
  ) {}

  ngOnInit() {
    this.subs.push(
      this.utilisateurCourantService.utilisateurCourantEvent.subscribe(user => {
        this.user = user;

        if (user != null) {
          this.individusService.getIndividuSimpleFromGuid(user.guid).subscribe(individu => {
            this.individu = individu;
          });
        }
      }),
    );
    this.subs.push(this.menuService.getMenuTop().subscribe(menu => {
      this.menu = menu;
      let apiMenu = new LienItemModel();
      apiMenu.iconClass = 'icon-book';
      apiMenu.isOutsideLink  = true;
      apiMenu.libelle = 'Documentation API';
      apiMenu.routerLink = `https://public-${this.configService.config.urlApi.split('://')[1]}/index.html`;
      menu.map(m => {
        if(m.libelle === "Aide"){
          m.sousMenu.splice(1, 0 , apiMenu)
        }
      })
    }));
    if(document.cookie.includes('menuOpen')){
      this.menuState = JSON.parse(this.cookieService.getCookie('menuOpen')).menuOpen;
      this.menuStateChange.emit(this.menuState);
    }

  }

  get menusDynamiques(): Array<MenuItemModel> {
    if (!this.menu) {
      return [];
    }

    return this.menu.filter(menu => !this.isMenuItemStatique(menu));
  }

  get menuItemMonCompte(): MenuItemModel {
    if (!this.menu) {
      return null;
    }

    return this.menu.find(menu => MenuTopComponent.isMenuItemMonCompte(menu));
  }

  get menuItemTaches(): MenuItemModel {
    if (!this.menu) {
      return null;
    }

    return this.menu.find(menu => MenuTopComponent.isMenuItemTaches(menu));
  }

  get menuItemPlanningTaches(): MenuItemModel {
    if (!this.menu) {
      return null;
    }
    return this.menu.find(menu => MenuTopComponent.isMenuItemPlanningTaches(menu));
  }

  private static isMenuItemMonCompte(menuItem: MenuItemModel): boolean {
    return menuItem.libelle == menusStatiques.MonCompte;
  }

  private static isMenuItemTaches(menuItem: MenuItemModel): boolean {
    return menuItem.libelle == menusStatiques.Taches;
  }

  private static isMenuItemPlanningTaches(menuItem: MenuItemModel): boolean {
    return menuItem.libelle == menusStatiques.PlanningTaches;
  }

  private isMenuItemStatique(menuItem: MenuItemModel): boolean {
    return Object.keys(menusStatiques).findIndex(key => menuItem.libelle == menusStatiques[key]) >= 0;
  }

  ngOnDestroy(): void {
    this.subs.forEach(it => it.unsubscribe());
  }

  switchMenuReduce() {
    this.menuState.isReduced = !this.menuState.isReduced;
    this.cookieService.setCookie('menuOpen', {menuOpen: this.menuState});
    this.menuStateChange.emit(this.menuState);
  }

  switchMenuMobileOpen() {
    this.menuState.isMenuMobileOpened = !this.menuState.isMenuMobileOpened;
    this.menuStateChange.emit(this.menuState);
  }

  navigateToAccueil() {
    this.navigationService.root.accueil.navigate();
    return false;
  }

  afficherPopupTaches() {
    this.tachesControlService.afficherPopup();
  }

  getPlatform() {
    const url = window.location.href;
    if (url.includes("dev") || url.includes("localhost")) {
      return 'dev';
    }
    if (url.includes("rct")) {
      return 'rct';
    }
    if (url.includes("preprod")) {
      return 'preprod';
    }
    return 'prod';
  };
}
